import React, { useState } from 'react';
import { ThemeProvider } from './context/ThemeContext';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Mission from './components/Mission';
import Roadmap from './components/Roadmap';
import LogoCloud from './components/LogoCloud';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import Volunteers from './components/Volunteers';
import Events from './components/Events';
import Verification from './components/Verification';
import ResourcesLibrary from './components/ResourcesLibrary';
import TransparencyLegal from './components/TransparencyLegal';
import ScrollToTop from './components/ScrollToTop';
import CertificateDisplay from './components/CertificateDisplay';
import AnnouncementPopup from './components/AnnouncementPopup';
import WelcomeLoader from './components/WelcomeLoader';
import ProtectedRoute from './components/ProtectedRoute';
import { Routes, Route } from 'react-router-dom';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <ThemeProvider>
        <WelcomeLoader onLoadingComplete={handleLoadingComplete} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen flex flex-col antialiased">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={
                <>
                  <Hero />
                  <About />
                  <Mission />
                  <Roadmap />
                  <LogoCloud />
                  <Contact />
                </>
              } />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/volunteers" element={<Volunteers />} />
              <Route path="/events" element={<Events />} />
              <Route path="/resources" element={<ResourcesLibrary />} />
              <Route path="/verify" element={<Verification />} />
              <Route path="/transparency" element={<TransparencyLegal />} />
              
              {/* Protected Routes - Redirect to home */}
              <Route 
                path="/resources/documents" 
                element={<ProtectedRoute redirectTo="/" showMessage={true} />} 
              />
              <Route 
                path="/resources/documents/*" 
                element={<ProtectedRoute redirectTo="/" showMessage={true} />} 
              />
              
              {/* Catch-all route for any other protected paths */}
              <Route 
                path="/documents" 
                element={<ProtectedRoute redirectTo="/" showMessage={true} />} 
              />
              <Route 
                path="/documents/*" 
                element={<ProtectedRoute redirectTo="/" showMessage={true} />} 
              />
              
              {/* 404 Catch-all route */}
              <Route 
                path="*" 
                element={<ProtectedRoute redirectTo="/" showMessage={false} />} 
              />
            </Routes>
          </main>
          <Footer />
          <ScrollToTop />
          <CertificateDisplay />
          <AnnouncementPopup />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;